import qs from 'qs';
import DOMPurify from 'dompurify';

const parseQS = (location) => {
  return qs.parse(DOMPurify.sanitize(location), { ignoreQueryPrefix: true });
};

export default parseQS;
